
import { User } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface PsychologistData {
  id: string;
  name: string;
  photo_url?: string;
  crp: string;
  rating?: number;
  specialties: string[];
}

interface PsychologistDisplayCardProps {
  psychologist: PsychologistData;
}

const PsychologistDisplayCard = ({ psychologist }: PsychologistDisplayCardProps) => {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-4">
          <div className="w-16 h-16 rounded-full overflow-hidden">
            <img 
              src={psychologist.photo_url || '/default-avatar.png'} 
              alt={psychologist.name}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-bold">{psychologist.name}</h3>
            <p className="text-muted-foreground">CRP: {psychologist.crp}</p>
            <div className="flex items-center gap-2 mt-1">
              <div className="flex items-center">
                <span className="text-yellow-400">⭐</span>
                <span className="text-sm font-medium ml-1">
                  {psychologist.rating || '4.8'}
                </span>
              </div>
              <span className="text-gray-300">•</span>
              <div className="flex flex-wrap gap-1">
                {psychologist.specialties.slice(0, 2).map((specialty, index) => (
                  <span
                    key={index}
                    className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full"
                  >
                    {specialty}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PsychologistDisplayCard;
